import { BaseEntityModel } from '/@/modules/core/app/models/abstracts/BaseEntityModel';
import { ModelType } from '/@/modules/core/app/constants/ModelType';
import { EstateAccount } from '@/modules/estateaccount/models/EstateAccount';
import { FinancialAccountTransaction } from '@/modules/financialaccount/models/FinancialAccountTransaction';
import { Document } from '@/modules/document/models/Document';

export class EstateDistributionPayment extends BaseEntityModel {
  id?: number;

  modelType?: string;

  modelId?: number;

  estateAccountId?: number;

  amountPaid?: number;

  isInterim?: boolean;

  estateAccount?: Relationship<EstateAccount>;

  financialAccountTransaction?: Relationship<FinancialAccountTransaction>;

  document?: Relationship<Document>;

  constructor(model: Partial<EstateDistributionPayment> = {}) {
    super(model);

    this.id = model.id;
    this.modelType = model.modelType;
    this.modelId = model.modelId;
    this.estateAccountId = model.estateAccountId;
    this.amountPaid = model.amountPaid;
    this.isInterim = model.isInterim;
    this.estateAccount = EstateAccount.mapModelOrNull(model.estateAccount);
    this.financialAccountTransaction =
      FinancialAccountTransaction.mapModelOrNull(model.financialAccountTransaction) ?? undefined;
    this.document = Document.mapModelOrNull(model.document) || undefined;
  }

  getModelName(): string {
    return ModelType.ESTATE_DISTRIBUTION_PAYMENT;
  }
}
